import linkUtility from '@sparta.credit-cards.utilities/link-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

/* eslint-disable import/no-unresolved */

/**
 * rating
 *
 * @description Ported over from S1 legacy sparta - displays stars,
 *  had to remove code due to undefined vars.
 * @param {Object} params data
 * @return {String} string for stars
 */
function starRating(params) {
  if (typeof params === 'string') {
    // Fix for carousel module's ratings
    try {
      // eslint-disable-next-line no-param-reassign
      params = JSON.parse(params);
    } catch (error) {
      console.error(error);
    }
  }
  const value = parseFloat(params.value, 10) || 0;
  const of = parseInt(params.of, 10) || 5;
  const full = Math.floor(value);
  const partial = value - full;
  let out = '<div class="rating" tabindex="-1" aria-hidden="true">';
  const closeOut = '</div>';
  let toggledOff = false;
  if (typeof params.toggle !== 'undefined') {
    if (params.toggle === false || params.toggle.toLowerCase() !== 'yes' && params.toggle.toLowerCase() !== 'on' && params.toggle.toLowerCase() !== 'true') {
      toggledOff = true;
    }
  }
  if (typeof value !== 'number' || value <= 0 || toggledOff) {
    if (typeof params.na === 'string') {
      return out + params.na + closeOut;
      // eslint-disable-next-line no-else-return
    } else {
      return '';
    }
  }
  let uniqueID = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let j;
  for (j = 0; j < 5; j++) {
    uniqueID += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  let wPercent;
  switch (params.source) {
    case 'quiz':
      wPercent = 100 / of;
      break;
    case 'mobile-quiz':
      wPercent = 80 / of;
      break;
    default:
      wPercent = 80 / of;
  }

  // eslint-disable-next-line prefer-template
  const svgStart = '<svg alt="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 30" preserveAspectRatio="xMidYMin meet" width="' + wPercent + '%" focusable="false" aria-hidden="true">';
  // eslint-disable-next-line prefer-template
  const clipPathA = '<defs><clipPath id="' + uniqueID + '"><rect width="';
  const clipPathB = '%" height="100%"/></clipPath></defs>';
  const emptyStar = '<polygon fill="none" stroke="#012169" stroke-linejoin="round" points="15.647 3 12.79 12.167 3.543 12.167 11.024 17.833 8.167 27 15.647 21.334 23.128 27 20.271 17.833 27.752 12.167 18.505 12.167"/>';
  const filledA = '<polygon fill="#012169" fill-rule="evenodd" stroke="#012169" stroke-linejoin="round" points="15.352 3 12.495 12.167 3.248 12.167 10.729 17.833 7.871 27 15.352 21.334 22.833 27 19.976 17.833 27.457 12.167 18.21 12.167"';
  const filledB = '/><polygon fill="#f5f5f5" opacity=".8" d="M43.992 38.25l.197-.577L54.567 6.08 52.93 1.036 41.14 37.323H2.984l4.12 2.993 36.214.007.672-2.073zm20.675-.927l1.25 3h.047l32.738-.007 4.12-2.993H64.666zM33.942 59.82L22.027 95.98l4.304-3.1 10.13-31.076-2.518-1.984z"/>';
  const filledStar = filledA + filledB;
  // eslint-disable-next-line prefer-template
  const partialStar = filledA + 'clip-path="url(#' + uniqueID + ')"' + filledB;
  const svgEnd = '</svg>';

  // Add required number of stars to output
  let i = 1;
  for (i; i <= of; i++) {
    out += svgStart;
    if (i <= full) {
      // Completely filled stars
      out += filledStar;
    } else {
      // eslint-disable-next-line no-lonely-if
      if (i === full + 1) {
        // Partially filled stars
        out += clipPathA + 100 * partial + clipPathB;
        out += emptyStar;
        out += partialStar;
      } else {
        // Empty stars
        out += emptyStar;
      }
    }
    out += svgEnd;
  }
  out += closeOut;
  if (params.fn || typeof params.linkConfig !== 'undefined') {
    let linkConfig = {};
    if (typeof params.linkConfig === 'object') {
      linkConfig = Handlebars.Utils.extend(params.linkConfig, params);
      delete linkConfig.linkConfig; // avoid confusion and reduce size of object
    } else {
      linkConfig = params;
    }
    let content = `${out}<div class="summary">`;
    if (params.fn) {
      content += params.fn(this);
    } else {
      content += linkConfig.content;
    }
    content += '</div>';
    linkConfig.content = content;
    out = linkUtility(linkConfig);
  }
  return new Handlebars.SafeString(out);
}

export { starRating as default };
